import {
  ChargingStationType as ApiChargingStationType,
  Connector as ApiConnector,
  ConnectorType,
  Current,
  Evse as ApiEvse,
  Manufacturer as ApiManufacturer,
  Phase
} from '@infuse/api/cpms/config';
import { ChargingStationType, Connector, Evse, Manufacturer } from './model';

export const mapManufacturerToDomain = (manufacturer: ApiManufacturer): Manufacturer => ({
  id: manufacturer.id || undefined,
  name: manufacturer.code
});

export const mapDomainToManufacturer = (manufacturer: Manufacturer): ApiManufacturer => ({
  id: manufacturer.id,
  code: manufacturer.name ? manufacturer.name : ''
});

export const mapDomainToNewManufacturer = (manufacturer: Manufacturer): ApiManufacturer => ({
  id: undefined,
  code: manufacturer.name ? manufacturer.name : ''
});

export const mapConnectorToDomain = (connector: ApiConnector): Connector => ({
  maxAmperage: connector.maxAmp,
  phases: connector.phase,
  voltage: connector.voltage,
  maxElectricPower: connector.maxElectricPower
    ? connector.maxElectricPower / 1000
    : connector.maxElectricPower === 0
    ? 0
    : undefined,
  physicalReference: connector.physicalReference,
  current: connector.current,
  connectorType: connector.connectorType
});

export const mapDomainToConnector = (connector: Connector): ApiConnector => ({
  id: undefined,
  maxAmp: connector.maxAmperage || 0,
  phase: connector.phases || Phase.UNKNOWN_NA,
  voltage: connector.voltage || 0,
  maxElectricPower:
    connector.maxElectricPower && connector.maxElectricPower !== 0 ? connector.maxElectricPower * 1000 : null,
  physicalReference: connector.physicalReference || null,
  current: connector.current || Current.UNSPECIFIED,
  connectorType: connector.connectorType || ConnectorType.UNSPECIFIED
});

export const mapEvseToDomain = (evse: ApiEvse): Evse => ({
  identifier: evse.identifier,
  capabilities: evse.capabilities,
  connectors: evse.connectors?.map(mapConnectorToDomain)
});

export const mapDomainToEvse = (evse: Evse): ApiEvse => ({
  id: undefined,
  identifier: evse.identifier,
  capabilities: evse.capabilities,
  connectors: evse.connectors?.map(mapDomainToConnector) ? evse.connectors.map(mapDomainToConnector) : []
});

export const mapDomainToChargingStationType = (chargingStationType: ChargingStationType): ApiChargingStationType => ({
  id: chargingStationType.id || undefined,
  code: chargingStationType.type ? chargingStationType.type : '',
  commercialCode: chargingStationType.commercialType || null,
  manufacturer: mapDomainToManufacturer(chargingStationType.manufacturer),
  evses: chargingStationType.evses?.map(mapDomainToEvse) ? chargingStationType.evses.map(mapDomainToEvse) : []
});

export const apiResultToDomain = (apiResult: ApiChargingStationType): ChargingStationType => {
  return {
    id: apiResult.id,
    type: apiResult.code,
    commercialType: apiResult.commercialCode || null,
    manufacturer: mapManufacturerToDomain(apiResult.manufacturer),
    evses: apiResult.evses?.map(mapEvseToDomain).sort((e1, e2) => e1.identifier - e2.identifier)
  };
};
